import * as actionTypes from "./actionTypes";

const initialState = {
	loading: false,
	storeConfig: null,
	currentRestaurant: null,
	brand: null,
	hasMultipleLocations: false,
	brandLocations: [],
	restaurantSlug: null,
	error: null,
};

const singlestoreReducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.GET_SINGLE_STORE_CONFIG:
			return { ...state, loading: true, error: null };

		case actionTypes.GET_SINGLE_STORE_CONFIG_SUCCESS:
			return {
				...state,
				loading: false,
				storeConfig: action.payload,
				currentRestaurant: action.payload.restaurant,
				brand: action.payload.brand,
				hasMultipleLocations: action.payload.has_multiple_locations,
			};

		case actionTypes.GET_SINGLE_STORE_CONFIG_ERROR:
			return { ...state, loading: false, error: action.payload };

		case actionTypes.GET_STORE_BY_LOCATION:
			return { ...state, loading: true, error: null };

		case actionTypes.GET_STORE_BY_LOCATION_SUCCESS:
			return {
				...state,
				loading: false,
				currentRestaurant: action.payload.restaurant,
				brand: action.payload.brand,
				hasMultipleLocations: action.payload.has_multiple_locations,
			};

		case actionTypes.GET_STORE_BY_LOCATION_ERROR:
			return { ...state, loading: false, error: action.payload };

		case actionTypes.GET_BRAND_LOCATIONS:
			return { ...state, loading: true, error: null };

		case actionTypes.GET_BRAND_LOCATIONS_SUCCESS: {
			// Ensure locations is always an array
			const nestedLocations =
				action.payload && action.payload.data && action.payload.data.locations
					? action.payload.data.locations
					: null;
			const locations = action.payload.locations || nestedLocations || [];
			console.log('🔄 Reducer: Setting brandLocations:', locations.length, locations);
			
			return {
				...state,
				loading: false,
				brand: action.payload.brand,
				brandLocations: Array.isArray(locations) ? locations : [],
			};
		}

		case actionTypes.GET_BRAND_LOCATIONS_ERROR:
			return { ...state, loading: false, error: action.payload };

		case actionTypes.SET_RESTAURANT_SLUG:
			return { ...state, restaurantSlug: action.payload };

		default:
			return state;
	}
};

export default singlestoreReducer;

